import ComponentBlock from '~/models/component-block';
import type PageInterface from '~/constants/interfaces/page-interface';
import { type ContentData } from '~/constants/types/page';

type PageType = {
  contentData: ContentData;
};

export default class Page implements PageInterface {
  contentData: ContentData;
  constructor(props: PageType) {
    this.contentData = props.contentData;
  }

  get title() {
    return this.contentData.title;
  }

  get components() {
    return this.contentData.components.map((component) => {
      return new ComponentBlock(component);
    });
  }

  get type() {
    return this.contentData.type;
  }

  get id() {
    return this.contentData.id;
  }

  get seo() {
    return this.contentData.seo;
  }

  get ecomId() {
    return this.contentData.ecom_id;
  }

  get retailers() {
    return this.contentData.retailers;
  }

  get policy() {
    return this.contentData.policy;
  }

  get content() {
    return this.contentData.content;
  }

  get quiz() {
    return this.contentData.quiz;
  }

  get looks() {
    return this.contentData.looks || [];
  }

  // Categories for shop the look page
  get categories() {
    return this.contentData.categories || [];
  }

  get products() {
    return this.contentData.products || [];
  }

  get image() {
    return this.contentData.image || null;
  }

  get images() {
    return this.contentData.images || [];
  }

  get template() {
    return this.contentData.template;
  }
}
